import { Link } from "react-router-dom";

function Footer() {
  const socialLinks = [
    {
      name: "Facebook",
      href: "https://facebook.com",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M13.5 21v-8h2.6l.4-3h-3v-1.9c0-.9.3-1.6 1.6-1.6h1.5V3.8c-.3 0-1.2-.1-2.3-.1-2.3 0-3.8 1.4-3.8 4V10H8v3h2.5v8h3z" />
        </svg>
      )
    },
    {
      name: "Instagram",
      href: "https://instagram.com",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M7.5 2h9A5.5 5.5 0 0 1 22 7.5v9a5.5 5.5 0 0 1-5.5 5.5h-9A5.5 5.5 0 0 1 2 16.5v-9A5.5 5.5 0 0 1 7.5 2zm0 2A3.5 3.5 0 0 0 4 7.5v9A3.5 3.5 0 0 0 7.5 20h9a3.5 3.5 0 0 0 3.5-3.5v-9A3.5 3.5 0 0 0 16.5 4h-9zm10 1.5a1 1 0 1 1 0 2 1 1 0 0 1 0-2zM12 7a5 5 0 1 1 0 10 5 5 0 0 1 0-10zm0 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6z" />
        </svg>
      )
    },
    {
      name: "LinkedIn",
      href: "https://linkedin.com",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M6.5 8A1.5 1.5 0 1 1 6.5 5a1.5 1.5 0 0 1 0 3zM5 9h3v10H5V9zm5 0h2.9v1.4h.1c.4-.8 1.4-1.6 2.9-1.6 3.1 0 3.7 2 3.7 4.7V19h-3v-4.8c0-1.1 0-2.6-1.6-2.6s-1.8 1.2-1.8 2.5V19h-3V9z" />
        </svg>
      )
    },
    {
      name: "YouTube",
      href: "https://youtube.com",
      icon: (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M22 12s0-3.3-.4-4.8a2.5 2.5 0 0 0-1.8-1.8C18.3 5 12 5 12 5s-6.3 0-7.8.4A2.5 2.5 0 0 0 2.4 7.2C2 8.7 2 12 2 12s0 3.3.4 4.8a2.5 2.5 0 0 0 1.8 1.8C5.7 19 12 19 12 19s6.3 0 7.8-.4a2.5 2.5 0 0 0 1.8-1.8c.4-1.5.4-4.8.4-4.8zm-12.5 3.5v-7l6 3.5-6 3.5z" />
        </svg>
      )
    }
  ];

  return (
    <footer className="site-footer brand-footer">
      <div className="footer-top">
        <section className="footer-brand">
          <img src="/assets/TP visuals gold.png" alt="PixelTone Audio Visuals" className="footer-logo" />
          <p className="footer-tagline">
            PixelTone Audio Visuals delivers premium event planning, technical production,
            and on-ground execution for corporate and experiential events across India.
          </p>
          <div className="social-links" aria-label="Social links">
            {socialLinks.map((item) => (
              <a key={item.name} href={item.href} target="_blank" rel="noreferrer" aria-label={item.name}>
                {item.icon}
              </a>
            ))}
          </div>
        </section>

        <section className="footer-links-col">
          <h4>Explore</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/services">Services</Link></li>
            <li><Link to="/our-work">Our Work</Link></li>
            <li><Link to="/careers">Careers</Link></li>
            <li><Link to="/gallery">Gallery</Link></li>
            <li><Link to="/blog">Blog</Link></li>
          </ul>
        </section>

        <section className="footer-links-col">
          <h4>Core Services</h4>
          <ul>
            <li>Corporate Conferences</li>
            <li>Product Launches</li>
            <li>Award Nights</li>
            <li>MICE Programs</li>
            <li>Virtual & Hybrid Events</li>
          </ul>
        </section>

        <section className="footer-contact-col">
          <h4>Contact</h4>
          <p><a href="mailto:contact@pixeltoneav.com">contact@pixeltoneav.com</a></p>
          <p><a href="tel:+919164866699">9164866699</a></p>
          <p>650/21, 46th Cross Rd, 3rd Block, Rajajinagar, Bengaluru, Karnataka 560010</p>
        </section>
      </div>

      <div className="footer-bottom">
        <p>PixelTone Audio Visuals</p>
        <p>Copyright 2026. All rights reserved.</p>
      </div>
    </footer>
  );
}

export default Footer;
